const { SK_AD_NETWORK_SANS_MACHINES_NAMES_WITH_NO_CAMPAIGN_ID_DATA } = require('./constants/adPartnerConstants');

const isSANAdPartnerWithNoCampaignIdData = (adPartnerMachineName) =>
  SK_AD_NETWORK_SANS_MACHINES_NAMES_WITH_NO_CAMPAIGN_ID_DATA.includes(adPartnerMachineName);

module.exports = isSANAdPartnerWithNoCampaignIdData;
